import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getAllArticulos as getArts, jsonDeserialize } from "../../API/request";

const initialState = {
  articulos: [],
  status: "idle",
  error: null,
};

export const fetchArts = createAsyncThunk("articulos/fetchArts", async () => {
  const response = await getArts();
  var arts = jsonDeserialize(response.data.data).articulos;
  return arts.data;
});

export const articulosSlice = createSlice({
  name: "articulos",
  initialState,
  reducers: {
    addArticulos: (state, action) => {
      state.articulos = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchArts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchArts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.articulos = action.payload;
      })
      .addCase(fetchArts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { addArticulos } = articulosSlice.actions;
export default articulosSlice.reducer;
